import React from "react";

import getRequest from "util/APIHelperGet";
import { baseUrl } from "util/APIBaseUrl";

import { usePermissions } from "components/Hook";
import { getDateInFormat } from "helpers";

import {
  FileDownloadOutlined as FileDownloadOutlinedIcon,
  CallReceivedOutlined as CallReceivedOutlinedIcon,
} from "@mui/icons-material";

import "./PayrollStubs.scss";

const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function PayrollStubs({ payrollData }) {
  const payloadDataRows = payrollData?.payload?.rows || [];

  const { loggedInUser } = usePermissions();

  const handleDownloadSlip = async (payrollId) => {
    const response = await getRequest(
      `${baseUrl}/employee/${loggedInUser?.userId}/payroll/${payrollId}?action=pdf`,
      true,
      "export"
    );

    if (!response?.ok) {
      return;
    }
    const url = window.URL.createObjectURL(response?.payload);
    const link = document.createElement("a");
    link.style.display = "none";
    link.href = url;

    link.download = "Salary Slip";
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(url);
  };

  return (
    <div className="ep-payroll-stubs">
      <div className="heading-h5-medium">Recent Paystubs</div>
      <div className="ep-payroll-stubs-divider" />
      <div className="flex flex-col gap-075">
        {(payrollData?.ok ? payloadDataRows.slice(-3) : [])?.map((stub) => {
          return (
            <div className="ep-payroll-stubs-item" id="payroll-stubs">
              <div className="ep-payroll-stubs-details">
                <div className="ep-payroll-stubs-icon-wrapper">
                  <CallReceivedOutlinedIcon className="ep-payroll-stubs-icon" />
                </div>
                <div className="flex flex-col items-start">
                  <p className="para-body-m-medium">{`${
                    monthNames[new Date(stub?.payslipMonth).getMonth()]
                  }' ${new Date(stub.payslipMonth).getFullYear()}`}</p>
                  <p className="ep-payroll-stubs-paid-on-text">
                    Paid on {getDateInFormat(stub?.payslipMonth)?.replace(/\d{4}$/, (year) => year.slice(-2))}
                  </p>
                </div>
              </div>
              <FileDownloadOutlinedIcon
                className="ep-payroll-stubs-download-icon"
                onClick={() => {
                  handleDownloadSlip(stub?.id);
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default PayrollStubs;
